export default __webpack_public_path__ + "assets/img/juara4.1970d4f6e5d5e15cdfa5f7469f00eb50.png";